import type { CauserSubjectItem } from "./causer-subject.type";
import type { ModelKey } from "@/modules/model";

import { useModelLink } from "@/modules/model-link";

export const useCauserSubjectLink = (
  model?: ModelKey,
  item?: CauserSubjectItem | null
) => {
  const { getModelLink } = useModelLink();

  if (!model || !item || item.deleted_at !== null) return undefined;

  return getModelLink(model, { id: item.id });
};
